export const RegiWallLoginMethodLocalstorageKey = "REGI_WALL_LOGIN_METHOD";
